import request from '@/utils/request'
import { xlsDownload } from '@/api/view/hip/common/commonXls'

export function epmsa310(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa310/epmsa310`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epmsa310Xls(param) {
  const data = param
  return request({
    url: `/outsoucingBlockControl/epmsa310/epmsa310Xls`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  }).then(res => {
    // console.log('epmsa310XlsRes', res)

    const filename = 'Steel Cutting Closing.xls'
    xlsDownload(filename, res)
  })
}

export function epmsa310Close(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa310/epmsa310Close`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}